const EMPTY_DETAIL = { application: {}, member: {} };

export function getKycApplications(state) {
    return state.KycReducer.applications || [];
}

/**
 * Defaulted, not just read: the whole slice is rehydrated from sessionStorage, so a session that
 * started before `detail` existed hands back the OLD shape and overrides initialState entirely.
 * Reading through this keeps the page working until that copy is replaced.
 */
export function getKycDetail(state) {
    return state.KycReducer.detail || EMPTY_DETAIL;
}

/** Defaulted for the same reason as getKycDetail — see above. */
export function getKycConnection(state) {
    return state.KycReducer.connection || { tested: false };
}
